// removed by extract-text-webpack-plugin
module.exports = {"radar":"antd-pro-radar","legend":"antd-pro-legend","legendItem":"antd-pro-legendItem","split":"antd-pro-split","dot":"antd-pro-dot"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/Radar/index.less
// module id = 402
// module chunks = 0 1